module.exports = __webpack_public_path__ + "img/Weapon_198.746ce45e.png";